/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';

import Spinner from '../../assets/img/loader.png';

import './styles.css';

class LoadMask extends Component {
	componentDidMount() {
		document.body.style.overflow = 'hidden';
	}

	componentWillUnmount() {
		document.body.style.overflow = 'visible';
	}

	render() {
		return (
			<CSSTransition classNames="LoadMask" in appear timeout={400}>
				<div className="LoadMask__backdrop">
					<img alt="" className="spinner" src={Spinner} />
					<span className="loader-text">{this.props.text}</span>
				</div>
			</CSSTransition>
		);
	}
}

export default LoadMask;



// WEBPACK FOOTER //
// ./src/components/loadMask/index.js